module.exports = __webpack_public_path__ + "img/010-dress.04df5c7c.png";